import React from 'react';

function HeroSection() {
  return (
    <section id="home" className="bg-gray-600">
      <h1 className='text-yellow-200 text-xl'>Your Shortcut to Modern Teaching Success</h1>
      <div className='flex flex-col items-center text-center'>
        <p className="text-lm md:text-lg font-medium text-white">
          Save time, avoid costly mistakes, and scale your business with 110+ expert-crafted documents.
        </p>
        <p className="text-m md:text-lg font-medium text-white mt-2">
          Built by a veteran with 30+ years of experience scaling multi-million-dollar ventures.
        </p>
        <button className='mt-4 px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg shadow hover:bg-blue-600 transition'>
          Get Instant Access Now
        </button>
      </div>
    </section>
  );
}

export default HeroSection;